// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"92b65b76","453":"d25a3014","732":"2418e531","977":"c014172c"}[chunkId] + ".chunk.js";
};